module.exports = __webpack_public_path__ + "media/newstyle/images/slider-arrow-left-grey-5b5f5d04ab51f57946eb15f65e8327ad.svg";